export enum RawChatHistoryEvent {
  LOAD_HISTORY = 'LOAD_HISTORY',
  ADD_NEW_MESSAGE = 'ADD_NEW_MESSAGE',
  UPDATE_MESSAGE = 'UPDATE_MESSAGE',
}

export default RawChatHistoryEvent;
